import React from "react";
import { toast } from "sonner";
import { Truck, MapPin, Clock, Copy } from "lucide-react";
import { SHIPMENT_STATUS_LABELS } from "@/data/services";
import { EmptyState } from "@/components/portal/PortalBits";

export function ShipmentsList({ shipments }) {
  if (shipments.length === 0) return <EmptyState label="No shipments linked to your account yet." />;
  return (
    <div className="space-y-4" data-testid="my-shipments-panel">
      {shipments.map((s) => (
        <div key={s.id} className="border border-slate-200 bg-white p-6" data-testid={`my-shipment-${s.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <Truck className="h-5 w-5 text-primary-brand" />
              <div>
                <div className="flex items-center gap-2 font-heading font-bold text-slate-900">
                  {s.tracking_number}
                  <button
                    onClick={() => { navigator.clipboard.writeText(s.tracking_number); toast.success("Copied"); }}
                    className="text-slate-400 hover:text-slate-900"
                  >
                    <Copy className="h-3.5 w-3.5" />
                  </button>
                </div>
                <div className="text-xs text-slate-500">{s.service_type}</div>
              </div>
            </div>
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-primary-brand">
              {SHIPMENT_STATUS_LABELS[s.current_status]}
            </span>
          </div>
          <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500">Origin</div>
              <div className="text-slate-900 mt-1 flex items-center gap-1"><MapPin className="h-3.5 w-3.5 text-primary-brand" />{s.origin}</div>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500">Destination</div>
              <div className="text-slate-900 mt-1 flex items-center gap-1"><MapPin className="h-3.5 w-3.5 text-primary-brand" />{s.destination}</div>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500">Last event</div>
              <div className="text-slate-900 mt-1 flex items-center gap-1"><Clock className="h-3.5 w-3.5 text-primary-brand" />
                {new Date(s.events?.[s.events.length - 1]?.timestamp || s.created_at).toLocaleString()}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
